import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import router from './router'
import overflowTitle from './directives/overflowTitle'

// Import Klinger themed Bootstrap styles
import './assets/styles/klinger-theme.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'

// Import Bootstrap JavaScript
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap

const app = createApp(App)

// Toast configuration - Klinger style without progress bar
const toastOptions = {
  position: 'top-right',
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: true,
  draggable: false,
  showCloseButtonOnHover: true,
  hideProgressBar: true,  // No countdown timer
  closeButton: 'button',
  icon: true,
  rtl: false,
  toastClassName: 'klinger-toast',
  bodyClassName: 'klinger-toast-body'
}

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)
app.directive('overflow-title', overflowTitle)

app.mount('#app')

// Initialize auth after app is mounted
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore()
authStore.initAuth()